module.exports = __webpack_public_path__ + "img/walt_btn.2ab9f32b.png";